import '.d{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.e{justify-content:center;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.bo{flex-grow:1;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.b2{max-width:77.5rem;}.ssr-plugin'
import '.da{justify-content:stretch;}.ssr-plugin'
import '.db{position:sticky;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.dc{z-index:10;}.ssr-plugin'
import '.dd{padding-block:1rem;}.ssr-plugin'
import '.de{height:3rem;}.ssr-plugin'
import '.a0{justify-content:space-between;}.ssr-plugin'
import '.df{flex-wrap:wrap;}.ssr-plugin'
import '.dg{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b0{margin-top:2rem;}.ssr-plugin'
import '.gf{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d ab e k cn"
      >
        <div className="bo d l e k"
        >
          <div className="b2 d k da db cg dc"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dd de d a0 l df"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dg d k ab b0 gf b2"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
